import React from 'react';
import { TeamMember } from '../types';
import './AdvisoryBoard.css';

const AdvisoryBoard: React.FC = () => {
  const advisoryBoardMembers: TeamMember[] = [
    {
      id: '1',
      name: 'Ed Hammel',
      role: 'International Advisory Board Member',
      bio: 'International expert in educational exchange programs promoting multicultural communication and understanding.',
      image: null
    },
    {
      id: '2',
      name: 'Marcel Van-Opstal',
      role: 'International Advisory Board Member',
      bio: 'Renowned peace advocate and international relations specialist, bringing decades of experience in fostering cross-cultural understanding and cooperation.',
      image: null
    },
    {
      id: '3',
      name: 'Prof. Taro Komatsu',
      role: 'International Advisory Board Member',
      bio: 'Distinguished professor and international expert in peace education and conflict resolution, contributing valuable insights to global peace-building initiatives.',
      image: null
    }
  ];

  return (
    <div className="advisory-board-page">
      {/* Hero Section */}
      <section className="advisory-hero section">
        <div className="container">
          <div className="advisory-hero-content text-center">
            <h1>International Advisory Board</h1>
            <p>Meet the distinguished global leaders and peace experts who provide strategic guidance to the Peja Peace Forum</p>
          </div>
        </div>
      </section>

      {/* Advisory Board Members Section */}
      <section className="advisory-members section">
        <div className="container">
          <div className="advisory-grid">
            {advisoryBoardMembers.map((member) => (
              <div key={member.id} className="advisory-card">
                <div className="advisory-info">
                  <h3 className="advisory-name">{member.name}</h3>
                  <p className="advisory-role">{member.role}</p>
                  <p className="advisory-bio">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdvisoryBoard;
